import { render, staticRenderFns } from "./Forgot.htm?vue&type=template&id=27f118c7&scoped=true&"
import script from "./Forgot.js?vue&type=script&lang=js&"
export * from "./Forgot.js?vue&type=script&lang=js&"
import style0 from "./Forgot.scss?vue&type=style&index=0&id=27f118c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f118c7",
  null
  
)

export default component.exports